import { StarfieldCanvas } from './starfield-canvas.js';

class CanvasManager {
    constructor() {
        this.canvas = document.getElementById('starfield-canvas');
        if (!this.canvas) {
            console.error('Canvas element not found!');
            return;
        }
        this.currentCanvas = null;
        this.theme = document.documentElement.getAttribute('data-theme') || 'dark';

        this.init();
        this.observeThemeChanges();
    }

    init() {
        this.switchCanvas(this.theme, true);
    }

    observeThemeChanges() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-theme') {
                    const newTheme = document.documentElement.getAttribute('data-theme');
                    if (newTheme !== this.theme) {
                        this.theme = newTheme;
                        this.switchCanvas(newTheme);
                    }
                }
            });
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme']
        });
    }

    switchCanvas(theme, isInitial = false) {
        if (!isInitial) {
            this.fadeOut(() => {
                this.createCanvas(theme);
                this.fadeIn();
            });
        } else {
            this.createCanvas(theme);
            this.fadeIn();
        }
    }

    createCanvas(theme) {
        if (this.currentCanvas && typeof this.currentCanvas.cleanup === 'function') {
            this.currentCanvas.cleanup();
        }

        if (theme === 'light') {
            this.currentCanvas = new StarfieldCanvas(this.canvas, 'cometsOnly');
        } else {
            this.currentCanvas = new StarfieldCanvas(this.canvas);
        }
    }

    fadeOut(callback) {
        this.canvas.style.transition = 'opacity 0.5s ease';
        this.canvas.style.opacity = 0;
        setTimeout(callback, 500);
    }

    fadeIn() {
        this.canvas.style.opacity = 1;
    }
}

export default CanvasManager;
